import React, { Fragment } from "react";

import { Autocomplete } from "@material-ui/lab";
import { Box, InputAdornment, TextField, makeStyles } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

import { LANGUAGES } from "@ds-developer/constants";

import { LanguageSelectorProps } from "../types";

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: theme.spacing(2),
    background: theme.palette.grey[50],
    borderRadius: "4px",
  },
  input: {
    background: theme.palette.common.white,
  },
}));

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  disabled = false,
  value,
  onChange = () => {},
}) => {
  const classes = useStyles();

  return (
    <div>
      <Autocomplete
        className={classes.wrapper}
        disableClearable
        forcePopupIcon={false}
        id="language-selector-autocomplete"
        multiple
        disabled={disabled}
        options={LANGUAGES}
        onChange={(_, values) => {
          onChange(values);
        }}
        ListboxProps={{
          ["data-test"]: "language-selector-list",
        }}
        ChipProps={{
          ["data-test"]: "language-selector-chip",
        }}
        value={value || []}
        renderInput={params => (
          <Fragment>
            <TextField
              {...params}
              className={classes.input}
              placeholder="Search for a language"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                // @ts-ignore
                ["data-test"]: "language-selector-input",
              }}
            />
            {/* These adornments are the 'selected' autocomplete entries */}
            <Box mt={2}>{params.InputProps.startAdornment}</Box>
          </Fragment>
        )}
      />
    </div>
  );
};

export default LanguageSelector;
